import React, { Component } from 'react';
import './reps.css';




class Reps extends Component {
    constructor(){
        super();
        this.state = {
            data:[]
        }

    };


    componentDidMount(){
        this.getData();
    }

    componentWillUnmount(){
        this.props.deInfo();
    }

    getData = () => {
        fetch((`/api/reps`))
        .then(res => res.json())
        .then(data => this.setState({
            data: data.data},()=>{
                this.props.initInfo()
            }));

  
      }
    
  

   

    render() {
        const { data } = this.state;
        const {win} = this.props;
        const {info} = this.props;
     
    return (
        
    
      <React.Fragment>
          
        
        

                
                {(data.length && info.length)?(
                    <React.Fragment >
                           
                                
                                       
                                            <div className="infoHold fullStage eCenter ptMed pbLrg noEvent">
                                                 
                                                      
                                            {data.map((item,i)=>{
                                                 return(
                                                     <div key={item.id} className='singleCountry ptSm pbMed bBlack bBotSm tBlack'>
                                                         <p className="countryName fullWidth mbXs textStage eCenter tUpper">{item.title}</p>
                                                         <div className="textStage eCenter tUpper" dangerouslySetInnerHTML={{ __html : item.about }}></div>

                                                     </div>
                                                    )
                                                })}
                                            
                                            </div>

                                
            
                          
                        </React.Fragment>
                ):('')}
                

    
       </React.Fragment>
    
    );
  }
}

export default Reps;



// WEBPACK FOOTER //
// ./src/components/reps/reps.js